export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-07.b2ec186d.jpg";